import { useCallback, useState } from 'react';

export function useToggle(initialState = false): [boolean, (forceUpdate?: boolean | unknown) => void] {
    const [state, setState] = useState(initialState);
    const toggle = useCallback((forceUpdate: boolean | unknown) => {
        setState((current) => (typeof forceUpdate === 'boolean' ? forceUpdate : !current));
    }, []);
    return [state, toggle];
}
